<template>
	<div ref="message" class="chat-message"></div>
</template>

<script>
import util from '../util';
import giftColorThresholds from '../GiftThresholds';

const styleId = 'chat-message-gift-thresholds-style';
let style = document.getElementById(styleId);
if(!style) {
	style = document.createElement('style');
	style.type = 'text/css';
	style.id = styleId;
	document.head.appendChild(style);
}

style.innerHTML = giftColorThresholds.map(t => `
	.chat-message > .message.gift.gift-${t.value} {
		color: ${util.getContrastingTextColor(t.color)};
		background-color: ${t.color};
	}
	.chat-message > .message.gift.gift-${t.value}:hover {
		background-color: ${t.secondaryColor||t.color};
	}
`).join('');

export default {
	name: 'ChatMessage',
	props: {
		item: Object,
		serviceIcons: Object,
		giftTypes: Object,
		select: Boolean,
		selected: Boolean,
		loading: Boolean,
		user: Object, // needed for current highlighted message
	},
	mounted() {
		this.updateMessageElem();
	},
	watch: {
		item() { this.updateMessageElem() },
		selected() { this.updateMessageElem() },
		loading() { this.updateMessageElem() },
		serviceIcons(newValue, oldValue) { if(newValue && !oldValue) this.updateMessageElem() },
	},
	methods: {
		updateMessageElem() {
			try {
				this.$refs.message.innerHTML = '';
				this.$refs.message.append(this.createMessageElem(this.item));
			} catch(e) {
				console.error(e);
			}
		},
		createMessageElem(msg) {
			return util.createChatLogMessage(msg, {
				serviceIcons: this.serviceIcons,
				user: this.user,
				giftTypes: this.giftTypes,
				// channels: this.channels,
				giftColorThresholds,
			}, {
				onclick: prepared => this.$emit('select', prepared),
				onmenuclick: prepared => this.$emit('menuclick', prepared),
			});
		},
		selectClick(event) {
			this.$emit('select', event);
		},
	}
}
</script>

<style lang="scss">
@import '../plugins/variable.scss';

.chat-message {
	padding: 2px;

	> .message {
		cursor: pointer;
		padding: 2px 4px;
		position: relative;
		img {
			max-width: 100%;
		}
		&:hover {
			background: rgba(255, 255, 255, .1);
			&:before {
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;
				text-align: center;
				background: rgba(255, 255, 255, .2);
				backdrop-filter: blur(3px);
				display: flex;
				align-items: center;
				justify-content: center;
				padding-left: 10px;
				padding-right: 10px;
				color: white;
			}
		}
		&.highlighted {
			background: $vaporwave-white;
			color: $dark;
		}
		&.gift {
			background: $gold;
			color: $gold-text;
			border-radius: 4px;
			padding: 4px;
			&:hover {
				background: darken($gold, 5%);
			}
		}
		> .avatar {
			max-width: 24px;
			max-height: 24px;
			border-radius: 12px;
			overflow: hidden;
		}
		> .service {
			max-width: 24px;
			max-height: 24px;
			border-radius: 12px;
			overflow: hidden;
		}
		> .name:after { content: ' ' }
		&.chat > .name:after { content: ': ' }
		> .content {
			display: inline;
			> img {
				max-width: 80px;
				max-height: 80px;

				&.emote {
					max-width: 32px;
					max-height: 32px;
				}
			}
		}
		&.self {
			color: fade-out($vaporwave-white, .4);
			&.highlighted {
				color: $dark;
			}
		}
		&.owner {
			color: $vaporwave-green;
			&.highlighted {
				color: $dark;
			}
		}
		> div.menubtn {
			display: none;
			position: absolute;
			font-size: 15px;
			right: 0;
			top: 0;
			bottom: 0;
			background: transparent;
			line-height: 100%;
			align-items: center;
			padding: 4px 24px;
			text-align: center;
			color: white;
			&:after {
				content: '⊕ Show';
			}
			backdrop-filter: blur(3px);
		}
		&.highlighted {
			> div.menubtn {
				&:hover {
				}
				&:after {
					content: '⊖ Hide';
				}
				color: $dark;
			}
		}
		&:hover > div.menubtn {
			display: inline-flex;
		}
		&:hover > div.menubtn:hover {
			background: rgba(255, 255, 255, .1);
		}
	}
}
</style>
